import { Button, Card, Empty, Table, Tag } from 'antd';
import { PageShell } from '../components/page-shell.js';
import { useAdminQuery } from '../use-admin-query.js';

type HealthRow = {
  credentialId: string;
  productKey: string;
  provider?: string;
  model?: string;
  status: string;
  code?: string;
  latencyMs?: number;
};

export function ProviderHealthPage() {
  const query = useAdminQuery<HealthRow[]>('/admin/v1/provider-health', false);
  return (
    <PageShell
      title="Provider health"
      description="Runs a bounded synthetic call with each active credential. No product content is used. Running checks may incur a small provider charge."
      action={
        <Button
          type="primary"
          loading={query.loading}
          onClick={() => void query.refresh()}
        >
          Run health checks
        </Button>
      }
      error={query.error}
    >
      <Card>
        {query.data ? (
          <Table
            rowKey="credentialId"
            pagination={false}
            dataSource={query.data}
            columns={[
              { title: 'Product', dataIndex: 'productKey' },
              { title: 'Provider', dataIndex: 'provider', render: dash },
              { title: 'Model', dataIndex: 'model', render: dash },
              {
                title: 'Status',
                dataIndex: 'status',
                render: (value: string) => (
                  <Tag
                    color={
                      value === 'healthy'
                        ? 'green'
                        : value === 'degraded'
                          ? 'orange'
                          : 'red'
                    }
                  >
                    {value}
                  </Tag>
                ),
              },
              {
                title: 'Latency',
                dataIndex: 'latencyMs',
                render: (value: unknown) =>
                  typeof value === 'number' ? `${value} ms` : '—',
              },
              { title: 'Code', dataIndex: 'code', render: dash },
            ]}
          />
        ) : (
          <Empty description="Run health checks when you need a current provider snapshot" />
        )}
      </Card>
    </PageShell>
  );
}

function dash(value: unknown): string {
  return typeof value === 'string' && value ? value : '—';
}
